import { useQuery } from '@tanstack/react-query';
import { FieldValues } from 'react-hook-form';

import { AsyncSelectControl, AsyncSelectControlProps } from '@/core/components';

import { reviewMembershipOptions } from './model/ReviewMembershipModel';

type ReviewMembershipSelectControlProps<T extends FieldValues> = Omit<
  AsyncSelectControlProps<T>,
  'isError' | 'isLoading' | 'options'
>;

export function ReviewMembershipSelectControl<T extends FieldValues>(props: ReviewMembershipSelectControlProps<T>) {
  const { data, isLoading, isError } = useQuery(reviewMembershipOptions.getAll());

  return (
    <AsyncSelectControl
      isError={isError}
      isLoading={isLoading}
      options={data ?? []}
      {...props}
    />
  );
}
